import { PropsWithChildren } from 'react';
import { MonkThemeProvider, useMonkAppState, useMonkTheme } from '@monkvision/common';

function RootStylesContainer({ children }: PropsWithChildren<unknown>) {
  const { rootStyles, palette } = useMonkTheme();

  return (
    <div className='app-container' style={{ ...rootStyles, color: palette.text.primary }}>
      {children}
    </div>
  );
}

export function AppContainer({ children }: PropsWithChildren<unknown>) {
  const { config } = useMonkAppState();

  return (
    <MonkThemeProvider palette={config.palette}>
      <RootStylesContainer>{children}</RootStylesContainer>
    </MonkThemeProvider>
  );
}
